import { gql } from '@apollo/client';

export const fetchSubscriptionsForTxaForWidget = gql`
  query fetchSubscriptionsForTxaForWidget(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          baseProduct
          transactionAccountId
          entitlementNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          cloudSiteId
          cloudSiteHostname
          logoId
          orgName
          orgProvisionedResourceType
        }
      }
    }
  }
`;
